import React, { Component, Fragment } from 'react';
import axios from 'axios';
import {
    Segment,
    Grid,
    Button,
    Header
} from 'semantic-ui-react';
import ExternalStudentPersonalInformationForm from './ExternalStudentPersonalInformationForm';
import ExternalStudentSendingInstitutionForm from './ExternalStudentSendingInstitutionForm';
import ExternalStudentExchangeInformationForm from './ExternalStudentExchangeInformationForm';
import { toast, ToastContainer } from 'react-toastify';
import { FormattedMessage } from 'react-intl';

export const externalStudentToBodyMapper = (student) => {
    return {
        id: student.id,
        firstName: student.firstName,
        lastName: student.lastName,
        email: student.email,
        dateOfBirth: student.dateOfBirth,
        birthCountryId: student.birthCountry ? student.birthCountry.id : null,
        birthPlaceName: student.birthPlaceName,
        citizenshipCountryId: student.citizenshipCountry ? student.citizenshipCountry.id : null,
        jmbg: student.jmbg,
        genderId: student.gender ? student.gender.id : null,
        fieldOfEducationId: student.fieldOfEducation ? student.fieldOfEducation.id : null,
        sendingInstitutionName: student.sendingInstitutionName,
        sendingInstitutionFacultyName: student.sendingInstitutionFacultyName,
        sendingInstitutionDepartment: student.sendingInstitutionDepartment,
        sendingInstitutionErasmusCode: student.sendingInstitutionErasmusCode,
        sendingInstitutionAddress: student.sendingInstitutionAddress,
        sendingInstitutionCountryId: student.sendingInstitutionCountry ? student.sendingInstitutionCountry.id : null,
        academicYearId: student.academicYear ? student.academicYear.id : null,
        mobilityProgramId: student.mobilityProgram ? student.mobilityProgram.id : null,
        mobilityTypeId: student.mobilityType ? student.mobilityType.id : null,
        studyTypeId: student.studyType ? student.studyType.id : null,
        sendingContactPersonFirstName: student.sendingContactPersonFirstName,
        sendingContactPersonLastName: student.sendingContactPersonLastName,
        sendingContactPersonEmail: student.sendingContactPersonEmail,
        sendingContactPersonPhone: student.sendingContactPersonPhone,
        europeanStudentIdentifier: student.europeanStudentIdentifier,
        englishLevelCompetenceId: student.englishLevelCompetence ? student.englishLevelCompetence.id : null,
        mobilityFormatId: student.mobilityFormat ? student.mobilityFormat.id : null,
        semesterId: student.semester ? student.semester.id : null,
        graduationDate: student.graduationDate,
        certificateNumber: student.certificateNumber,
        dropoutDate: student.dropoutDate,
        lockedAt: student.lockedAt,
        studyCycleId: student.studyCycle ? student.studyCycle.id : null,
        registrationLinkId: student.registrationLink ? student.registrationLink.id : null,
        studyProgramId: student.studyProgram ? student.studyProgram.id : null,
        nonCycleProgramId: student.nonCycleProgram ? student.nonCycleProgram.id : null,
        languageIds: student.languages ? student.languages.map(l => l.id) : null,
        scholarshipAmount: student.scholarshipAmount || null,
    };
};

export const validateExternalStudent = (student) => {
    return {
        firstNameErr: !student.firstName || student.firstName.trim() === '',
        lastNameErr: !student.lastName || student.lastName.trim() === '',
        emailErr: !student.email || student.email.trim() === '',
        dateOfBirthErr: !student.dateOfBirth || isNaN(new Date(student.dateOfBirth).getTime()),
        genderErr: !student.gender || !student.gender.id,
        birthCountryErr: !student.birthCountry || !student.birthCountry.id,
        englishLevelCompetenceErr: !student.englishLevelCompetence || !student.englishLevelCompetence.id,
        birthPlaceNameErr: !student.birthPlaceName || student.birthPlaceName.trim() === '',
        citizenshipCountryErr: !student.citizenshipCountry || !student.citizenshipCountry.id,
        jmbgErr: !student.jmbg || student.jmbg.trim() === '',

        mobilityProgramErr: !student.mobilityProgram || !student.mobilityProgram.id,
        mobilityFormatErr: !student.mobilityFormat || !student.mobilityFormat.id,
        academicYearErr: !student.academicYear || !student.academicYear.id,
        fieldOfEducationErr: !student.fieldOfEducation || !student.fieldOfEducation.id,
        studyTypeErr: !student.studyType || !student.studyType.id,
        semesterErr: student.mobilityType && student.mobilityType._key === 'cycle' && (!student.semester || !student.semester.id),
        studyProgramErr: student.mobilityType && student.mobilityType._key === 'cycle' && !student.studyProgram,
        nonCycleProgramErr: student.mobilityType && student.mobilityType._key === 'non_cycle' && !student.nonCycleProgram,
        mobilityTypeErr: !student.mobilityType || !student.mobilityType.id,
        studyCycleErr: !student.studyCycle || !student.studyCycle.id,

        sendingInstitutionNameErr: !student.sendingInstitutionName || student.sendingInstitutionName.trim() === '',
        sendingInstitutionFacultyNameErr: !student.sendingInstitutionFacultyName || student.sendingInstitutionFacultyName.trim() === '',
        // sendingInstitutionErasmusCodeErr: !student.sendingInstitutionErasmusCode || student.sendingInstitutionErasmusCode.trim() === '',
        sendingInstitutionCountryErr: !student.sendingInstitutionCountry || !student.sendingInstitutionCountry.id,
        sendingContactPersonFirstNameErr: !student.sendingContactPersonFirstName || student.sendingContactPersonFirstName.trim() === '',
        sendingContactPersonLastNameErr: !student.sendingContactPersonLastName || student.sendingContactPersonLastName.trim() === '',
        sendingContactPersonEmailErr: !student.sendingContactPersonEmail || student.sendingContactPersonEmail.trim() === '',
    };
};

export const getProgramName = (student) => {
    try {
        if (student.mobilityType._key === 'non_cycle') {
            return student.nonCycleProgram.programName;
        } else if (student.mobilityType._key === 'cycle') {
            return student.studyProgram.studyProgramBasic.name;
        } else {
            return '-';
        }
    } catch (e) {
        return '-';
    }
};

class ExternalStudentInputForm extends Component {
    state = {
        student: {},
        errors: {},
        saving: false,
    };

    constructor() {
        super();

        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleChange = this.handleChange.bind(this);
    }

    componentDidMount() {
    }

    handleSubmit = () => {
        const { student } = this.state;

        const body = externalStudentToBodyMapper(student);

        const errors = validateExternalStudent(student);
        this.setState({ errors });
        if (Object.values(errors)
            .some((err) => err)) {
            toast(<FormattedMessage id="externalStudent.toast.fillRequiredFields"/>);
            return;
        }

        this.setState({ saving: true }, () => {
            axios.post('/external-student', body)
                .then((res) => {
                    const createdStudent = res.data;

                    this.setState({
                        saving: false,
                        student: {}
                    });

                    localStorage.setItem('externalStudentId', createdStudent.id);
                    this.props.history.push({
                        pathname: '/dolazne-mobilnosti/student',
                        state: {
                            student: createdStudent,
                            defaultTabIndex: 1,
                            toastMessage: 'externalStudent.toast.createSuccess'
                        }
                    });
                })
                .catch(() => {
                    this.setState({
                        saving: false,
                    });
                    toast(<FormattedMessage id="externalStudent.toast.createError"/>);
                });
        });
    };

    handleChange = (updatedFields) => {
        this.setState((prevState) => ({
            student: {
                ...prevState.student,
                ...updatedFields
            }
        }));
    };

    render() {
        const {
            student,
            errors,
            saving,
        } = this.state;

        return (
            <Fragment>
                <Header as="h1">
                    <Header.Content>{<FormattedMessage id="externalStudent.createExternalStudent"/>}</Header.Content>
                </Header>

                <Segment.Group raised>
                    <Segment>
                        <Header as="h3">
                            <Header.Content>{<FormattedMessage
                                id="externalStudent.enterPersonalAndInstitutionData"/>}</Header.Content>
                        </Header>
                    </Segment>

                    <Segment>
                        <Grid stackable columns={2}>
                            <Grid.Column>
                                <Segment.Group>
                                    <ExternalStudentPersonalInformationForm student={student} errors={errors}
                                                                            onChangeStudent={this.handleChange}/>
                                </Segment.Group>
                                <Segment.Group>
                                    <ExternalStudentExchangeInformationForm student={student} errors={errors}
                                                                            onChangeStudent={this.handleChange}/>
                                </Segment.Group>
                            </Grid.Column>
                            <Grid.Column>
                                <Segment.Group>
                                    <ExternalStudentSendingInstitutionForm student={student} errors={errors}
                                                                           onChangeStudent={this.handleChange}/>
                                </Segment.Group>
                            </Grid.Column>
                        </Grid>
                    </Segment>

                    <Segment textAlign="right" padded>
                        <Button color="blue" onClick={this.handleSubmit} loading={saving}>
                            {<FormattedMessage id="externalStudent.confirm"/>}
                        </Button>
                        <Button basic color="blue" disabled={saving} onClick={() => {
                            this.setState({ student: {} });
                        }}>
                            {<FormattedMessage id="externalStudent.clear"/>}
                        </Button>
                    </Segment>
                </Segment.Group>
                <ToastContainer position="top-right" hideProgressBar={true}/>
            </Fragment>
        );
    }
}

export default ExternalStudentInputForm;



// WEBPACK FOOTER //
// ./src/views/ExternalStudents/ExternalStudentForms/ExternalStudentInputForm.js